import { API_ORIGIN, apiUrl } from "./apiOrigin";
import React, { useEffect, useState } from 'react';
const endpoint = apiUrl("/api/headoffice/compliance-grid/cell/next-due");
const day = value => value ? new Date(value).toISOString().slice(0, 10) : '';
export default function ComplianceNextDue({
  cell,
  rowId,
  dbName,
  token,
  readOnly = false,
  onChanged
}) {
  const initial = cell?.validUntil || cell?.evidence?.nextDueAt || cell?.expiresAt;
  const [date, setDate] = useState(day(initial)),
    [saved, setSaved] = useState(day(initial));
  const [busy, setBusy] = useState(false),
    [message, setMessage] = useState('');
  useEffect(() => {
    setDate(day(initial));
    setSaved(day(initial));
    setMessage('');
  }, [initial, cell?.evidence?.at]);
  if (!cell?.evidence?.at) return null;
  const save = async () => {
    setBusy(true);
    setMessage('');
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token || localStorage.getItem('token') || ''}`
        },
        body: JSON.stringify({
          rowId,
          dbName,
          nextDueAt: date,
          evidenceAt: cell.evidence.at,
          updatedBy: 'Head office'
        })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || 'Unable to save next due date.');
      setSaved(day(result.nextDueAt));
      setMessage('Next due date saved.');
      await onChanged?.();
    } catch (e) {
      setMessage(e.message);
    } finally {
      setBusy(false);
    }
  };
  return <section aria-label="Next due date" style={{
    padding: 10,
    marginTop: 10,
    border: '1px solid #D9D9D9',
    borderRadius: 6,
    fontSize: 13
  }}>
    <div><b>Evidence provided:</b> {new Date(cell.evidence.at).toLocaleDateString('en-GB')}</div>
    <div style={{
      marginTop: 6
    }}><b>Next due:</b> {saved ? new Date(saved + 'T00:00:00').toLocaleDateString('en-GB') : 'No next due date recorded'}</div>
    {!readOnly && <div style={{
      marginTop: 8,
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      flexWrap: 'wrap'
    }}>
      <label>Change next due date <input aria-label="Change next due date" type="date" value={date} disabled={busy} onChange={e => setDate(e.target.value)} onInput={e => setDate(e.target.value)} /></label>
      <button disabled={busy || !date || date === saved} onClick={save}>Save next due date</button>
    </div>}
    {message && <div role="status" style={{
      marginTop: 6
    }}>{message}</div>}
  </section>;
}
